import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";

// Catch-all inside the app shell so unmatched URLs keep the site chrome and,
// crucially, emit server-rendered noindex metadata instead of inheriting the
// indexable root marketing tags.
export const Route = createFileRoute("/_app/$")({
  head: () =>
    buildHead({
      title: "Page not found | LohaLink",
      description:
        "This LohaLink page could not be found. Browse live scrap rates, verified yards and market insights instead.",
      canonical: "/",
      noindex: true,
    }),
  component: lazyRouteComponent(() => import("@/pages/NotFound")),
});
